import Image from 'next/image'

import { apps as allAppsData } from '../../../../../../../components/apps/apps-data'

interface IELDAppIconProps {
  appType: string
}

/**
 * Renders the ELD app icon or fallback emoji.
 */
export const ELDAppIcon = ({ appType }: IELDAppIconProps) => {
  const imageURL = allAppsData.find((a) => a.appType === appType)?.darkImageURL ?? null

  if (imageURL) {
    return (
      <div className="w-5 h-5 rounded overflow-hidden flex items-center justify-center">
        <Image src={imageURL} alt={appType} width={20} height={20} className="object-contain" />
      </div>
    )
  }

  return <span className="text-base">📊</span>
}
